<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">任务点统计</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 开发完成时间</p>
            <p>排序: 任务点总数正序（默认）</p>
            <p>描述: 所选时间段内各团队或个人负责任务点数和任务数</p>
            <p>操作: 点击右上角团队/个人可切换查看视角<cursor /></p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="onChange">
          <a-radio-button value="team"> 团队 </a-radio-button>
          <a-radio-button value="person"> 个人 </a-radio-button>
        </a-radio-group>
      </div>
      <div id="task-point-rank" :style="{ height: height, width: width }" />
    </a-card>
    <task-point-modal :filter-from="detailFilterForm" :display="detailVisible" @close="close" />
  </div>
</template>
<script>
import { taskPointRank } from '@/api/data/task';
import TaskPointModal from '@/pages/data/task/components/TaskPointModal';
export default {
  components: { TaskPointModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'team',
      loading: true,
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      data: [],
      detailFilterForm: {},
      detailVisible: false
    };
  },
  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      const echarts = require('echarts/lib/echarts');
      require('echarts/lib/chart/bar'); // 柱状图
      // 下面的是需要的提示框
      require('echarts/lib/component/tooltip');
      require('echarts/lib/component/legend');
      require('echarts/lib/component/grid');
      require('echarts/lib/component/dataZoom');
      this.myChart = echarts.init(document.getElementById('task-point-rank'));
      this.myChart.setOption(this.option, true);
      const self = this;
      this.myChart.getZr().on('click', function (param) {
        const pointInPixel = [param.offsetX, param.offsetY];
        // 判断给定的点是否在指定的坐标系或者系列上
        if (self.myChart.containPixel('grid', pointInPixel)) {
          // 获取到点击的 x轴 下标  转换为逻辑坐标
          const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
          // self.onDetail(index);
        }
      });
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    onChange(e) {
      this.utils.trackClick({ name: '任务点统计切换', label: e.target.value === 'team' ? '团队' : '个人' });
      this.getTaskPointRank();
    },
    getTaskPointRank() {
      this.loading = true;
      taskPointRank({ ...this.filterForm, sorter: 'point_count', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          const x_axis = [];
          const point_count_series = [];
          const task_count_series = [];
          this.data.forEach(el => {
            x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
            task_count_series.push(el.task_count);
            point_count_series.push(el.point_count);
          });
          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '任务点数',
              data: point_count_series
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '任务数',
              data: task_count_series
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDetail(index) {
      this.detailVisible = true;
      this.detailFilterForm = {
        begin_date: this.filterForm.begin_date,
        end_date: this.filterForm.end_date
      };
      if (this.showModal === 'team') {
        this.detailFilterForm.team_id = this.data[index].team_id;
      } else {
        this.detailFilterForm.user_id = this.data[index].user_id;
      }
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
